const userPaths = {
  about: '/about',
  privacyPolicy: '/privacy-policy',
  offer: '/offer',
  contacts: '/contacts',
  projects: '/projects',
  project: '/project',
  settings: '/settings',
  support: '/support',
  supportAppealSuggestion: '/support/appeal/suggestion',
  supportAppealProblem: '/support/appeal/problem',
  supportAppealQuestion: '/support/appeal/question',
  discoveries: '/discoveries',
  expired: '/expired',
  authRedirect: '/auth-redirect',
  referral: '/referral',
  invoices: '/invoices',
  content: '/content',
} as const

export const pathsWithString = {
  home: '/',
  login: '/login',
  register: '/register',
  finish: '/finish',
  restorePassword: '/restore-password',
  createProject: '/projects/create',
  invite: 'invite',
  llmChat: '/llm-chat',
  ...userPaths,
} as const

type ID = number | string | string[]

export const paths = {
  ...pathsWithString,

  supportAppeal: (id: string | number): string => `/support/appeal/${id}`,
  supportCreateAppeal: (id: string | number): string => `/support/appeal/create/${id}`,
  diagnostics: (id: ID): string => `/projects/${id}/diagnostics`,
  hypotheses: (id: ID): string => `/projects/${id}/hypotheses`,
  discoveries: (id: ID): string => `/projects/${id}/discoveries`,
  projectWithSlug: (id: ID): string => `/projects/${id}`,
  createHypothesis: ({ projectId, taskId }: { projectId: ID; taskId: ID }): string =>
    `/projects/${projectId}/tasks/${taskId}/hypotheses/create`,

  createHypothesisReportPdf: ({ projectId }: { projectId: string }): string => `/projects/${projectId}/hypotheses.pdf`,
  createCaseReportPdf: ({ projectId }: { projectId: string }): string => `/projects/${projectId}/case.pdf`,

  task: ({ projectId, taskId }: { projectId: ID; taskId: ID }): string => `/projects/${projectId}/tasks/${taskId}`,
  taskTool: ({ projectId, taskId, toolId }: { projectId: ID; taskId: ID; toolId: ID }): string =>
    `/projects/${projectId}/tasks/${taskId}/tools/${toolId}`,
  tasks: ({ projectId }: { projectId: ID }): string => `/projects/${projectId}/tasks`,
  projectFiles: ({ projectId }: { projectId: ID }): string => `/projects/${projectId}/files`,
  projectCase: ({ projectId }: { projectId: ID }): string => `/projects/${projectId}/case`,
  projectEdit: ({ projectId }: { projectId: ID }): string => `/projects/${projectId}/edit`,
  projectPoint: (projectId: ID): string => `/projects/${projectId}/point`,
  taskslist: (projectId: ID): string => `/projects/${projectId}/taskslist`,
  tool: ({ projectId, toolCode }: { projectId: ID; toolCode: ID }): string =>
    `/projects/${projectId}/tools/${toolCode}`,
} as const
